export const isIOSDevice = () => {
  const userAgent = navigator.userAgent || window.opera;
  // iOS detection
  return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
};

export const isAndroid = () => /android/i.test(window.navigator.userAgent);